import { tsValidateString } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
const Validator_ModifiableProps = {
    key: tsValidateString(),
    label: tsValidateString(),
};
const Validator_GeneratedProps = {};
export const DBDef_NLPModel = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'nlp-model',
    entityName: 'nlp-model',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'nlp-model'
    },
    backend: {
        name: 'nlp-model'
    }
};
//# sourceMappingURL=db-def.js.map